<template>
  <div
    class="bbp-popup-info"
    :class="[
      isRevert && 'bbp-popup-info_bottom',
      !isRevert && 'bbp-popup-info_top',
      isLeft && 'bbp-popup-info_left',
      isTextDefault && 'bbp-popup-info_text-initial'
    ]"
    :style="popupStyle"
    @click="onClick"
  >
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'BBPPopupInfo',
  props: {
    text: {
      type: String,
      default: ''
    },
    popupStyle: {
      type: Object,
      default: () => ({})
    },
    isRevert: {
      type: Boolean,
      default: false
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isTextDefault: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick () {
      this.$emit('onHandlerClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-popup-info {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 4px 7px;
    background: rgba($color-black, 0.55);
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-white;
    border-radius: 3px;
    z-index: 999;
    pointer-events: none;
    text-transform: capitalize;
    user-select: none;

    &_text-initial {
      text-transform: initial;
    }

    &:before {
       content: '';
       position: absolute;
       left: auto;
       display: block;
       width: 0;
       height: 0;
       border-left: 3px solid transparent;
       border-right: 3px solid transparent;
    }

    &_bottom {
      &:before {
        bottom: -3px;
        border-top: 3px solid rgba($color-black, 0.55);
      }
    }

    &_top {
      &:before {
        top: -3px;
        border-bottom: 3px solid rgba($color-black, 0.55);
      }
    }

    &_left {
      &:before {
        left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPPopups/BBPPopupInfo.vue